import React from "react";
import { PropagateLoader } from "react-spinners";

export const BarLoader = () => {
  return <PropagateLoader color="#6da9b3" size={15} />;
};
